import { Injectable } from "@angular/core";
import { IDateInfoCollection } from "@ramudden/models/date-info";
import { IProject, ProjectCreator, ProjectUpdater } from "@ramudden/models/project";
import { ISearchResult } from "@ramudden/models/search";
import { firstValueFrom, Observable } from "rxjs";
import { ApiService } from "./api";

@Injectable({
    providedIn: "root",
})
export class ProjectApi extends ApiService<IProject, ProjectCreator, ProjectUpdater> {
    override getRoute(): string {
        return "Projects";
    }

    getDataDates$(projectId: number): Observable<IDateInfoCollection> {
        const url = `${super.getUrl()}/${projectId}/Dates`;
        return this.handleCaching(url);
    }

    public async getAll(): Promise<ISearchResult<IProject>> {
        return await firstValueFrom(this.http.get<ISearchResult<IProject>>(this.getUrl()));
    }
}
